import { useEffect, useState } from 'react';
import { carService } from '../services/carService';
import { notifyError, notifySuccess } from '../utils/notifications';

export default function CarInfo({ isOpen, onClose, car, workshopID }) {
    const [editableData, setEditableData] = useState({
        marca: '',
        sub_marca: '',
        matricula: '',
        modelo: '',
        color: '',
        VIN: '',
        motor: '',
        transmission: 'MANUAL',
    });

    useEffect(() => {
        if (car) {
            setEditableData({
                marca: car.marca || '',
                sub_marca: car.sub_marca || '',
                matricula: car.matricula || '',
                modelo: car.modelo || '',
                color: car.color || '',
                VIN: car.VIN || '',
                motor: car.motor || '',
                transmission: car.transmission || 'MANUAL',
            });
        }
    }, [car]);

    const handleInputChange = (field, value) => {
        setEditableData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSave = async () => {
        try {
            const carID = car.id;

            if (!carID) {
                console.error('No se encontró car_id en:', car);
                notifyError('Error: No se pudo identificar el vehículo');
                return;
            }

            if (!workshopID) {
                notifyError('Error: No se pudo identificar el taller');
                return;
            }

            const payload = {
                marca: editableData.marca,
                sub_marca: editableData.sub_marca,
                matricula: editableData.matricula,
                modelo: editableData.modelo,
                color: editableData.color,
                VIN: editableData.VIN,
                motor: editableData.motor,
                transmission: editableData.transmission,
            };

            await carService.updateVehicle(carID, payload, workshopID);
            notifySuccess('Vehículo actualizado exitosamente');
            onClose(!isOpen);
        } catch (error) {
            console.error('Error al guardar vehículo:', error);
            if (error.response?.status === 404) {
                notifyError('Vehículo no encontrado');
            } else if (error.response?.status === 403) {
                notifyError('No tienes permiso para editar este vehículo');
            } else {
                notifyError('Error al guardar los cambios');
            }
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={() => { onClose(!isOpen); }}>
            <div className="modal-container modal-large" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Información del Vehículo</h2>
                    <button className="close-button" onClick={() => { onClose(!isOpen); }}>✕</button>
                </div>

                <div className="modal-body">
                    {/* Identificación del vehículo */}
                    <div className="form-row">
                        <div className="form-group">
                            <label>Marca *</label>
                            <input
                                type="text"
                                value={editableData.marca}
                                onChange={(e) => handleInputChange('marca', e.target.value)}
                                placeholder="Ej: Toyota, Ford, Nissan..."
                            />
                        </div>

                        <div className="form-group">
                            <label>Submarca / Versión *</label>
                            <input
                                type="text"
                                value={editableData.sub_marca}
                                onChange={(e) => handleInputChange('sub_marca', e.target.value)}
                                placeholder="Ej: Corolla, Focus, Versa..."
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Matrícula / Placas *</label>
                            <input
                                type="text"
                                value={editableData.matricula}
                                onChange={(e) => handleInputChange('matricula', e.target.value)}
                                placeholder="Número de placas..."
                            />
                        </div>

                        <div className="form-group">
                            <label>Año / Modelo *</label>
                            <input
                                type="text"
                                value={editableData.modelo}
                                onChange={(e) => handleInputChange('modelo', e.target.value)}
                                placeholder="Ej: 2020, 2021..."
                            />
                        </div>
                    </div>

                    {/* Características técnicas */}
                    <div className="form-row">
                        <div className="form-group">
                            <label>Color</label>
                            <input
                                type="text"
                                value={editableData.color}
                                onChange={(e) => handleInputChange('color', e.target.value)}
                                placeholder="Color del vehículo..."
                            />
                        </div>

                        <div className="form-group">
                            <label>Tipo de transmisión *</label>
                            <select
                                value={editableData.transmission}
                                onChange={(e) => handleInputChange('transmission', e.target.value)}
                            >
                                <option value="MANUAL">Manual</option>
                                <option value="AUTO">Automática</option>
                                <option value="CVT">CVT</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Número de serie (VIN)</label>
                            <input
                                type="text"
                                value={editableData.VIN}
                                onChange={(e) => handleInputChange('VIN', e.target.value)}
                                placeholder="17 caracteres alfanuméricos..."
                                maxLength="17"
                            />
                        </div>

                        <div className="form-group">
                            <label>Número de motor</label>
                            <input
                                type="text"
                                value={editableData.motor}
                                onChange={(e) => handleInputChange('motor', e.target.value)}
                                placeholder="Identificación del motor..."
                            />
                        </div>
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="btn-cancel" onClick={() => { onClose(!isOpen); }}>
                        Cerrar
                    </button>
                    <button className="btn-save" onClick={handleSave}>
                        Guardar cambios
                    </button>
                </div>
            </div>
        </div>
    );
}
